import classNames from "classnames";

type PageWrapperTypes = {
  children: any;
  classes?: string;
};
const PageWrapper = ({ children, classes }: PageWrapperTypes) => {
  return (
    <div
      className={classNames(
        "p-8 h-full w-full overflow-hidden",
        classes ?? classes
      )}
    >
      {children}
    </div>
  );
};

export default PageWrapper;
